import ErrorMessage from "@pages/ErrorMessage"
import Landing from "@pages/Landing"
import Landsec from "@pages/Landsec"
import Sites from "@pages/Sites"
import Overview from "@pages/Overview"

const routes = [
  {
    name: "Introduction",
    path: "/", 
    onNav: true,
    element: Landing,
  },
  {
    name: "Landsec",
    path: "/landsec", 
    onNav: true,
    element: Landsec,
  },
  {
    name: "Map",
    path: "/map", 
    onNav: true,
    element: Overview,
  },
  {
    name: "Seed Portfolio",
    path: "/sites", 
    onNav: true,
    element: Sites,
  },
  {
    name: "Seed Portfolio",
    path: "/sites/:id", 
    onNav: false,
    element: Sites,
  },
  { 
    path: "/*", 
    name: "Not Found", 
    onNav: false, 
    element: ErrorMessage 
  },
]

export default routes
